// Production endpoints are the default.
const DEFAULT_SEND_ENDPOINT =
  'https://j3l20pfmvj.execute-api.ap-south-1.amazonaws.com/prod/sendForStampNSign';
const DEFAULT_DOWNLOAD_ENDPOINT =
  'https://ea4d4kkub5.execute-api.ap-south-1.amazonaws.com/prod/downloadStampNSignDocument';

const DEFAULT_ACCESS_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2OTFkNmZjNzQxYThmYjkzOTAzZjU4MzkifQ.d_kFtxKiqHkbCGthDZpwWQ82YuyKIQ-jX8GKu7uq1-o';

export const eStampConfig = {
  endpoint: process.env.REACT_APP_ESTAMP_ENDPOINT || DEFAULT_SEND_ENDPOINT,
  downloadEndpoint: process.env.REACT_APP_ESTAMP_DOWNLOAD_ENDPOINT || DEFAULT_DOWNLOAD_ENDPOINT,
  accessToken: process.env.REACT_APP_ESTAMP_ACCESS_TOKEN || DEFAULT_ACCESS_TOKEN,
  documentCategory: process.env.REACT_APP_ESTAMP_DOCUMENT_CATEGORY || 'serviceagm',
  eStampAmount: Number(process.env.REACT_APP_ESTAMP_AMOUNT || 500),
  consideration: Number(process.env.REACT_APP_ESTAMP_CONSIDERATION || 100000),
  eStampState: process.env.REACT_APP_ESTAMP_STATE || 'KA',
  payingParty: process.env.REACT_APP_ESTAMP_PAYING_PARTY || 'self',
  // esignMethod removed - not supported by API
  callbackUrl:
    process.env.REACT_APP_ESTAMP_CALLBACK_URL ||
    'https://us-central1-douglas-924ae.cloudfunctions.net/estampWebhook',
  firstParty: {
    firstName: process.env.REACT_APP_ESTAMP_FIRST_PARTY_FIRST_NAME || 'Steadeesoft AI',
    lastName: process.env.REACT_APP_ESTAMP_FIRST_PARTY_LAST_NAME || 'Technologies',
    countryCode: process.env.REACT_APP_ESTAMP_FIRST_PARTY_COUNTRY_CODE || '+91',
    phone: process.env.REACT_APP_ESTAMP_FIRST_PARTY_PHONE || '9606816002',
    email: process.env.REACT_APP_ESTAMP_FIRST_PARTY_EMAIL || 'partnership@steadeesoft.com',
  },
};
